if (!customElements.get('variant-specifications')) {
  customElements.define(
    'variant-specifications',
    class VariantSpecifications extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-specifications-content]');
        this.status = this.querySelector('[data-specifications-status]');
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, this.onVariantChange.bind(this));
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        this.abortController?.abort();
      }

      async onVariantChange({ data: { event, target, selectedOptionValues } }) {
        const productInfo = event.target.closest('product-info');
        // Quick-add modals and featured products must not change the main product's specs.
        if (productInfo?.dataset.updateUrl !== 'true' || productInfo.dataset.productId !== this.dataset.productId) return;

        this.abortController?.abort();
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.content.hidden = true;
        this.status.textContent = this.status.dataset.loadingMessage;
        this.status.hidden = false;
        this.setAttribute('aria-busy', 'true');

        // Combined-listing product changes replace the entire page, including this table.
        if (target.dataset.productUrl && target.dataset.productUrl !== productInfo.dataset.url) return;

        try {
          const url = new URL(productInfo.dataset.url, window.location.origin);
          url.searchParams.delete('variant');
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('option_values', selectedOptionValues.join(','));
          const response = await fetch(url, { signal });
          if (!response.ok) throw new Error(`Specifications request failed: ${response.status}`);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (signal.aborted || !this.isConnected) return;
          const source = Array.from(html.querySelectorAll('variant-specifications')).find(
            (element) => element.dataset.productId === this.dataset.productId && element.dataset.sectionId === this.dataset.sectionId
          );
          const content = source?.querySelector('[data-specifications-content]');
          if (!content) throw new Error('Specifications missing from the section response');

          // Update only the table's contents, preserving the open tab or accordion.
          this.content.innerHTML = content.innerHTML;
          this.dataset.variantId = source.dataset.variantId;
          this.dataset.specsSource = source.dataset.specsSource;
          this.content.hidden = false;
          this.status.hidden = true;
        } catch (error) {
          if (signal.aborted || !this.isConnected) return;
          this.status.textContent = this.status.dataset.errorMessage;
          console.error(error);
        } finally {
          if (!signal.aborted && this.isConnected) this.removeAttribute('aria-busy');
        }
      }
    }
  );
}
